/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', updateCarouselTabIndex);
  document.addEventListener('DOMContentLoaded', updateAddressTabIndex);
  document.addEventListener('DOMContentLoaded', updateReviewsTabIndex);
  document.addEventListener('DOMContentLoaded', initTickerAccessibility);
  document.addEventListener('DOMContentLoaded', initSortToggleAccessibility);
  document.addEventListener('DOMContentLoaded', initAccessibleAccordion);
  document.addEventListener('DOMContentLoaded', initMegamenuSingleOpen);
  document.addEventListener('DOMContentLoaded', initHiddenFocusGuard);
  document.addEventListener('DOMContentLoaded', adjustDisclaimerTextSizeWithClass);
  updateEmailPlaceholder();
  styleNoThanksButton();
  addTabindexToDots();
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();




function initTickerAccessibility() {
  const frames = document.querySelectorAll('[data-ticker-frame]');
  if (!frames.length) return;

  // The theme's Ticker clones each message (cloneNode) to create the
  // marquee loop, leaving every link focusable in up to 11 duplicates.
  // Keyboard focus then walks the clones while the browser scrolls the
  // frame to chase them. Remove clones from the tab order and the
  // accessibility tree as they are created.
  const neutralizeClones = (frame) => {
    frame.querySelectorAll('[data-clone]').forEach((clone) => {
      if (clone.getAttribute('aria-hidden') === 'true') return;
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
    });
  };

  frames.forEach((frame) => {
    neutralizeClones(frame);
    new MutationObserver(() => neutralizeClones(frame)).observe(frame, {childList: true, subtree: true});

    // Pausing the animation isn't enough for keyboard focus: the marquee
    // transform may have carried the original (focusable) message out of
    // the frame, so focus lands on a link hidden behind a clone and the
    // browser scrolls the clipped frame chasing it. While focus is inside,
    // remove the animation class entirely — the transform snaps off and
    // the original message sits fully visible at its natural position
    // (same mechanism the theme's own toggleTicker uses). Restore on exit.
    let frozen = [];

    frame.addEventListener('focusin', () => {
      if (frozen.length) return;
      frozen = Array.from(frame.querySelectorAll('[data-ticker-text].ticker--animated'));
      frozen.forEach((el) => el.classList.remove('ticker--animated'));
      // Undo any scroll the browser already did chasing the pre-snap position.
      requestAnimationFrame(() => {
        frame.scrollLeft = 0;
        frame.querySelectorAll('[data-ticker-scale]').forEach((el) => {
          el.scrollLeft = 0;
        });
      });
    });

    frame.addEventListener('focusout', (event) => {
      if (frame.contains(event.relatedTarget)) return;
      frozen.forEach((el) => el.classList.add('ticker--animated'));
      frozen = [];
      // Clear focus-chasing scroll offsets so the resumed marquee isn't shifted.
      frame.scrollLeft = 0;
      frame.querySelectorAll('[data-ticker-scale]').forEach((el) => {
        el.scrollLeft = 0;
      });
    });
  });
}

function initHiddenFocusGuard() {
  // Two theme.js behaviors defeat the static aria-hidden/tabindex="-1"
  // markup that every product-card snippet now ships (a11y P0 #3):
  //
  // 1. The carousel/tab code re-enables tabindex="0" on `.product__media__holder`
  //    links whenever their cell joins the active tab group — including cells
  //    that are scrolled out of view and still carry aria-hidden="true" (the
  //    home featured-collection carousel; axe: aria-hidden-focus). The media
  //    link is a presentational duplicate everywhere — the title link is the
  //    canonical tab stop — so it must never re-enter the tab order.
  //
  // 2. Carousel cells get aria-hidden="true" while focusable content inside
  //    them stays live: the PDP upsell holder (upsell-product.liquid only
  //    pre-mutes links for index > 1) and the home blog-item cells, where
  //    theme.js mutes a/button but not the NESTED Flickity product slider —
  //    Flickity gives its viewport div tabindex="0" and nothing resets it.
  //
  // theme.js is minified and never edited, so re-assert the correct state
  // AFTER its writes with one attribute-level observer (same approach as
  // initTickerAccessibility above). All handlers are idempotent, so the
  // observer cannot loop: our own writes leave nothing left to change.
  const MEDIA_LINK = '.product__media__holder';
  const HIDDEN_CONTAINERS = '[data-upsell-holder], .blog-item';
  // Marks elements the guard muted and remembers their prior tabindex, so
  // restores (a) never touch elements whose tabindex="-1" is static and
  // intentional (e.g. media links) and (b) give back the exact prior value —
  // a nested Flickity viewport needs its tabindex="0" back, not removal.
  const MUTED_MARK = 'data-bb-focus-guard';

  const muteMediaLink = (el) => {
    if (el.getAttribute('tabindex') !== '-1') el.setAttribute('tabindex', '-1');
  };

  const syncHiddenContainer = (holder) => {
    if (holder.getAttribute('aria-hidden') === 'true') {
      holder.querySelectorAll('a[href], button, [tabindex]').forEach((el) => {
        if (el.getAttribute('tabindex') === '-1') return;
        el.setAttribute(MUTED_MARK, el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      });
    } else {
      // Visible again: hand focusability back only to elements we muted,
      // restoring the value they had (theme.js re-manages links from here).
      holder.querySelectorAll('[' + MUTED_MARK + ']').forEach((el) => {
        const prev = el.getAttribute(MUTED_MARK);
        if (prev) {
          el.setAttribute('tabindex', prev);
        } else {
          el.removeAttribute('tabindex');
        }
        el.removeAttribute(MUTED_MARK);
      });
    }
  };

  document.querySelectorAll(MEDIA_LINK).forEach(muteMediaLink);
  document.querySelectorAll(HIDDEN_CONTAINERS).forEach(syncHiddenContainer);

  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.attributeName === 'tabindex' && m.target.matches && m.target.matches(MEDIA_LINK)) {
        muteMediaLink(m.target);
      }
      if (m.attributeName === 'aria-hidden' && m.target.matches && m.target.matches(HIDDEN_CONTAINERS)) {
        syncHiddenContainer(m.target);
      }
    });
  }).observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['tabindex', 'aria-hidden'],
  });
}

function initMegamenuSingleOpen() {
  const NAV_ITEM = '[data-nav-item]';
  const TOP_LINK = '[data-top-link]';
  const OPEN = 'is-visible';

  // The desktop megamenu (theme.js) opens a dropdown on BOTH mouseenter and
  // top-link focus, but a mouse-opened panel only closes on the trigger's
  // mouseleave. Moving from mouse-hover to keyboard leaves the cursor parked on
  // the hovered trigger, so its mouseleave never fires; tabbing then focuses the
  // next top-link and opens a second panel on top of the first. The panels are
  // full-width and share an origin, so they overlap (the garbled menu).
  //
  // Enforce a single open panel: when focus lands on a top-level link, close
  // every OTHER open panel using the theme's own close signal (a synthetic
  // mouseleave — the same event the theme dispatches in its tablet handler).
  // Focus moving into a panel's child links is ignored (they are not
  // [data-top-link]), so an open panel stays open while browsed.
  //
  // CRITICAL: this MUST run on the CAPTURE phase of `focus` (not bubbling
  // `focusin`). The theme's per-panel `hideDisclosure()` removes the SHARED
  // `--header-background-height` on a single [data-header-background] element.
  // The newly-focused link's own `focus` handler runs `showDisclosure()` which
  // re-asserts that height. If we closed siblings on the bubble phase (after the
  // target's handler), the sibling's hideDisclosure would tear the shared
  // backdrop back down to 0 AFTER the open panel set it — leaving the open panel
  // transparent (page shows through). Running on capture closes stale siblings
  // BEFORE the focused panel opens, so showDisclosure has the last word.
  const closeOthers = (current) => {
    if (!current) return;
    document.querySelectorAll(NAV_ITEM + '.' + OPEN).forEach((item) => {
      if (item !== current) {
        item.dispatchEvent(new Event('mouseleave', { bubbles: true }));
      }
    });
  };

  document.addEventListener(
    'focus',
    (event) => {
      const link = event.target.closest && event.target.closest(TOP_LINK);
      if (!link) return;
      closeOthers(link.closest(NAV_ITEM));
    },
    true
  );
}

function updateCarouselTabIndex() {
  const carousels = document.querySelectorAll('[home-carousel-1]');
  carousels.forEach(carousel => carousel.setAttribute('tabindex', '-1'));
}

function updateAddressTabIndex() {
  const addressDiv = document.getElementById('home-address');
  if (addressDiv) addressDiv.setAttribute('tabindex', '-1');
}

function updateReviewsTabIndex() {
  const reviewsDiv = document.getElementById('home-testimonials-slider');
  if (reviewsDiv) reviewsDiv.setAttribute('tabindex', '-1');
}

function initSortToggleAccessibility() {
  const toggleButton = document.querySelector('[data-sort-toggle]');
  const optionsWrapper = document.querySelector('[data-collection-sort-options]');

  if (!toggleButton || !optionsWrapper) return;

  toggleButton.addEventListener('click', () => {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    toggleButton.setAttribute('aria-expanded', String(!isExpanded));
    optionsWrapper.hidden = isExpanded;
  });
}

function initAccessibleAccordion() {
  const triggers = document.querySelectorAll('[data-collapsible-trigger]');

  triggers.forEach(trigger => {
    const wrapper = trigger.closest('li');
    const container = wrapper.querySelector('[data-collapsible-container]');
    const content = container.querySelector('[data-collapsible-content]');

    trigger.addEventListener('click', () => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      // Toggle ARIA attributes
      trigger.setAttribute('aria-expanded', String(!isExpanded));
      container.setAttribute('aria-hidden', String(isExpanded));

      // Set focusability
      content.setAttribute('tabindex', isExpanded ? '-1' : '0');
    });
  });
}

function isModalOpen() {
  const modal = document.querySelector('.kl-private-reset-css-Xuajs1.needsclick');
  return modal && getComputedStyle(modal).display !== 'none';
}

function updateEmailPlaceholder() {
  const interval = setInterval(() => {
    if (!isModalOpen()) return;

    const emailInput = document.querySelector(
      'input[type="email"][name="email"].kl-private-reset-css-Xuajs1.go2767398544'
    );

    if (emailInput && emailInput.placeholder === "What is your email?") {
      emailInput.placeholder = "What is your email? (Required)";
      clearInterval(interval); 
    }
  }, 500);
}


function styleNoThanksButton() {
  const interval = setInterval(() => {
    if (!isModalOpen()) return;

    const buttons = document.querySelectorAll('button[type="button"]');
    let styled = false;

    buttons.forEach(button => {
      if (button.textContent.trim() === "No Thanks") {
        styled = true;

        button.style.border = "1px solid #333";
        button.style.backgroundColor = "#f5f5f5";
        button.style.borderRadius = "4px";
        button.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
        button.style.transition = "background-color 0.2s ease, box-shadow 0.2s ease";
        button.style.fontWeight = "600";
        button.style.margin = "0 5px";

        button.addEventListener("mouseover", () => {
          button.style.backgroundColor = "#e0e0e0";
          button.style.boxShadow = "0 3px 6px rgba(0, 0, 0, 0.15)";
        });

        button.addEventListener("mouseout", () => {
          button.style.backgroundColor = "#f5f5f5";
          button.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
        });
      }
    });

    if (styled) clearInterval(interval);
  }, 500);
}


function adjustDisclaimerTextSizeWithClass() {
  const interval = setInterval(() => {
    const modal = document.querySelector(
      '.kl-private-reset-css-Xuajs1.needsclick'
    );

    if (modal && getComputedStyle(modal).display !== 'none') {
      const allSpans = modal.querySelectorAll('span');
      allSpans.forEach(span => {
        const text = span.textContent.trim();
        if (
          text.startsWith('By subscribing') &&
          text.includes('unsubscribe')
        ) {
          span.style.fontSize = '12px';
          clearInterval(interval); 
        }
      });
    }
  }, 300);
}

function addTabindexToDots() {
  const interval = setInterval(() => {
    const dots = document.querySelectorAll('.flickity-page-dots li.dot');
    if (dots.length > 0) {
      dots.forEach(dot => {
        dot.setAttribute('tabindex', '0');
      });
      clearInterval(interval);
    }
  }, 500);
}

function redirectFocusToModalEmail() {
  const interval = setInterval(() => {
    const modal = document.querySelector('.kl-private-reset-css-Xuajs1.needsclick');

    if (!modal || getComputedStyle(modal).display === 'none') return;

    const emailInput = modal.querySelector(
      'input[type="email"][name="email"].kl-private-reset-css-Xuajs1.go2767398544'
    );

    if (!emailInput) return;

    // Ensure email input is focusable
    emailInput.setAttribute('tabindex', '0');

    // Watch for focus changes
    document.addEventListener('focusin', (e) => {
      if (!modal.contains(e.target)) {
        // If focus moves outside modal, bring it back to email input
        e.stopPropagation();
        emailInput.focus();
      }
    });

    clearInterval(interval); // Setup done
  }, 300);
}

function addKeyboardAccessibleCarouselToggle() {
  const scaleEl = document.querySelector('.announcement__scale');
  if (!scaleEl) return;

  const button = document.createElement('button');
  button.textContent = 'Pause Carousel';
  button.className = 'carousel-toggle-button';
  button.setAttribute('aria-pressed', 'false');

  button.style.position = 'absolute';
  button.style.left = '-9999px';
  button.style.top = '0';
  button.style.zIndex = '10000';

  button.addEventListener('focus', () => {
    button.style.left = '0rem';
    button.style.top = '0rem';
    button.style.background = '#fff';
    button.style.border = '1px solid #333';
    button.style.padding = '20px 28px';
    button.style.borderRadius = '4px';
    button.style.fontSize = '14px';
    button.style.cursor = 'pointer';
  });

  button.addEventListener('blur', () => {
    button.style.left = '-9999px';
  });

  button.addEventListener('click', () => {
    const isPaused = !scaleEl.style.getPropertyValue('--animation-time');
    
    if (isPaused) {
      // Resume
      scaleEl.style.setProperty('--animation-time', '14s'); 
      button.textContent = 'Pause Carousel';
      button.setAttribute('aria-pressed', 'false');
    } else {
      // Pause
      scaleEl.style.removeProperty('--animation-time');
      button.textContent = 'Play Carousel';
      button.setAttribute('aria-pressed', 'true');
    }
  });

  // Append button
  scaleEl.appendChild(button);
}

function updateSlideshowTabIndex() {
  const slideshow = document.querySelector('[data-slider]');
  if (slideshow) slideshow.setAttribute('tabindex', '-1');
}


